 
import { printAfterFiscal } from "../pos/print";
import api from "./api";

 const bearer = () => {
  const t = localStorage.getItem("device_token");
  //login with only device id 

  if (!t) {
      registerDevice({ uuid: localStorage.getItem("device_uuid") || undefined }).catch(() => {});

    throw new Error("Nema tokena");
  }
  return t;
};

/** DEVICE AUTH */
export async function registerDevice(opts: { uuid?: string; code?: string }) {
  const r = await api.post(`/pos/device/register`, opts);
  const { token } = r.data || {};
  if (token) localStorage.setItem("device_token", token);
  if (r.data.device) localStorage.setItem("pos.device", JSON.stringify(r.data.device));
  return r.data;
}
export async function pinLogin(pin: string) {
  const r = await api.post(
    `/pos/auth/pin`,
    { pin },
    { headers: { Authorization: "Bearer " + bearer() } }
  );
  return r.data as { employee: { id:number; name:string; role:string; outlet_id?: number } };
}

/** KATALOG (prefer /pos/catalog; fallback na /pos/categories + /pos/products) */
export async function fetchPosCatalog() {
  const auth = { headers: { Authorization: "Bearer " + bearer() } };

  try {
    const r = await api.get(`/pos/catalog`, auth);
    const data = Array.isArray(r.data) ? r.data : [];
    return data.map((row:any)=>({
      category: row.category,
      products: (row.products||[]).map((p:any)=>({
        ...p,
        modifierGroups: p.modifierGroups || p.modifier_groups || [],
      })),
    }));
  } catch (e:any) {
    if (e?.response?.status && e.response.status !== 404) throw e;
  }

  // fallback
  const [catsRes, prodsRes] = await Promise.all([
    api.get(`/pos/categories`, { ...auth, params: { visible_on_pos: 1 } }),
    api.get(`/pos/products`,   { ...auth, params: { visible_on_pos: 1 } }),
  ]);

  const categories = Array.isArray(catsRes.data) ? catsRes.data : [];
  const productsRaw = Array.isArray(prodsRes.data) ? prodsRes.data : [];
  const products = productsRaw.map((p:any)=>({ ...p, modifierGroups: p.modifierGroups || p.modifier_groups || [] }));

  const byCat: Record<number,{category:any; products:any[]}> = {};
  for (const c of categories) byCat[c.id] = { category: c, products: [] };
  for (const p of products) if (byCat[p.category_id]) byCat[p.category_id].products.push(p);
  return Object.values(byCat).filter(r => r.products.length > 0);
}

/** NARUDŽBA (kuhinja/šank) — PosOrderController@store */
export async function createOrder(payload: {
  client_uuid?: string;
  table_label?: string;
  outlet_id: number;
  number?: string;
  payment_type?: "cash"|"card"|"virman"|"cheque";
  payment_status?: "unpaid"|"partial"|"paid";
  customer_id?: number | null;
  note?:string;
  items: Array<{
    client_uuid?: string;
    product_id: number;
    quantity: number;
    unit_price?: number;
    modifiers?: Array<{ modifier_id: number; price?: number }>;
  }>;
}) {
  const r = await api.post(`/pos/orders`, payload, {
    headers: { Authorization: "Bearer " + bearer(), "Content-Type": "application/json" },
  });
  return r.data;
}

/** FISKALNI RAČUN — PosSaleController@store (Tring) */
export async function submitSale(payload: {
  order_id?: number;
  client_id?: number;
  outlet_id?: number;
  items: Array<{
    product_id?: number;
    code?: string | null;
    name: string;
    unit?: string;
    price: number;
    vat?: string;
    qty: number;
    discount?: number;
    modifiers?: Array<{ price_delta?: number; name?: string }>;
  }>;
  payments: Array<{ type: string; amount: number }>;
  customer?: { name?: string; pib?: string; address?: string; postal?: string; city?: string };
}) {
  const r = await api.post(`/pos/sales`, payload, {
    headers: { Authorization: "Bearer " + bearer(), "Content-Type": "application/json" },
  });
  return r.data;

  
}

export async function fetchReceipts(limit = 100) {
  const r = await api.get(`/pos/receipts`, {
    headers: { Authorization: "Bearer " + bearer() },
    params: { limit },
  });
  return r.data as Array<{ id:number; number?:string; total:number; status:string; created_at?:string }>;
}

export async function voidReceipt(id: number) {
  const r = await api.post(`/pos/receipts/${id}/void`, {}, {
    headers: { Authorization: "Bearer " + bearer() },
  });
  return r.data;
}

 
// --- interni snapshot i since ---
let _snapshot: Record<number, any> = {};
let _initialized = false;
let _since = Number(localStorage.getItem("tvq.since") || 0);

// svakih N poziva radi FULL refresh (since=0) da očisti uklonjene/završene
const FULL_REFRESH_EVERY = 12; // ~svakih 60s ako zoveš na 5s
let _tick = 0;

function snapshotToArray() {
  // možeš promijeniti sortiranje po želji
  return Object.values(_snapshot).sort((a: any, b: any) => a.id - b.id);
}

/**
 * Vraća PUNU listu za TV (interno održava snapshot + delta).
 * - šalje ?since=...
 * - čuva serverTime kao novi since
 * - periodično radi full refresh (since=0) da počisti nestale narudžbe
 */
export async function listNotPaidOrders(): Promise<any[]> {
  const doFull = !_initialized || (_tick++ % FULL_REFRESH_EVERY === 0);
  const since = doFull ? 0 : (_since || 0);
  const paymentStatusFilter = ['unpaid','partial'];

  const r = await api.get(`/pos/open`, {
    headers: { Authorization: "Bearer " + bearer() },
    params: { since, wait: true, payment_status: paymentStatusFilter },
  });

  const payload = r?.data ?? {};
  const rows: any[] =
    Array.isArray(payload) ? payload :
    Array.isArray(payload?.data) ? payload.data :
    Array.isArray(payload?.rows) ? payload.rows :
    [];

  const serverTime = typeof payload?.serverTime === "number" ? payload.serverTime : null;

  if (doFull) {
    // reset i popuni full snapshot
    _snapshot = {};
    for (const o of rows) _snapshot[o.id] = o;
    _initialized = true;
  } else {
    // delta merge: upiši/azuriraj samo promijenjene/nove
    for (const o of rows) _snapshot[o.id] = o;
    // brisanja rješavamo full refreshom povremeno
  }

  if (serverTime && serverTime > 0) {
    _since = serverTime;
    localStorage.setItem("tvq.since", String(_since));
  }

  return snapshotToArray();
}
export async function listOpenOrders(): Promise<any[]> {
  const doFull = !_initialized || (_tick++ % FULL_REFRESH_EVERY === 0);
  const since = doFull ? 0 : (_since || 0);

  const r = await api.get(`/pos/open`, {
    headers: { Authorization: "Bearer " + bearer() },
    params: { since }, // možeš dodati i wait/statuses ako želiš
  });

  const payload = r?.data ?? {};
  const rows: any[] =
    Array.isArray(payload) ? payload :
    Array.isArray(payload?.data) ? payload.data :
    Array.isArray(payload?.rows) ? payload.rows :
    [];

  const serverTime = typeof payload?.serverTime === "number" ? payload.serverTime : null;

  if (doFull) {
    // reset i popuni full snapshot
    _snapshot = {};
    for (const o of rows) _snapshot[o.id] = o;
    _initialized = true;
  } else {
    // delta merge: upiši/azuriraj samo promijenjene/nove
    for (const o of rows) _snapshot[o.id] = o;
    // brisanja rješavamo full refreshom povremeno
  }

  if (serverTime && serverTime > 0) {
    _since = serverTime;
    localStorage.setItem("tvq.since", String(_since));
  }

  return snapshotToArray();
}


export async function fiscalizeOrder(orderId: number, payments?: Array<{type:string; amount:number}>) {
const r = await api.post(`/pos/orders/${orderId}/fiscalize`, payments ? { payments } : {}, {
headers: { Authorization: 'Bearer ' + bearer() },
});
return r.data;
}

 
export async function getCatalog() {
  const r = await api.get(`/pos/catalog`, { headers: { Authorization: 'Bearer ' + bearer() } });
  return r.data;
}
 

 
export async function runPresjek() {
  const r = await api.post(`/pos/reports/presjek`, {}, { headers: { Authorization: 'Bearer ' + bearer() } });
  return r.data;
}

export async function runDnevni() {
  const r = await api.post(`/pos/reports/dnevni`, {}, { headers: { Authorization: 'Bearer ' + bearer() } });
  return r.data;
}

export async function runPeriodicni(from: string, to: string) {
  const r = await api.post(`/pos/reports/periodicni`, { from, to }, { headers: { Authorization: 'Bearer ' + bearer() } });
  return r.data;
}

 // === Order Ticket (Narudžba poslana) ===
export type OrderTicketItem = {
  name: string;
  qty: number;
  modifiers?: string[];
  note?: string | null;
};

export async function printOrderTicket(
  orderNumber: string | number,
  items: OrderTicketItem[],
  opts: { printerIp?: string; printerShare?: string }
) {
  try {
    const code = String(orderNumber).padStart(4, "0"); // 4 digits

    // Pretvori u linije pogodne za postojeću funkciju printAfterFiscal:
    // - glavna stavka kao "qty × name"
    // - svaki modifier ide u zasebnu liniju sa prefiksom "  • "
    // - napomena ide kao "  ✎ note"
    const flat: Array<{ name: string; qty: number; price: number }> = [];

    flat.push({ name: `====  ORDER #${code}  ====`, qty: 1, price: 0 });
    flat.push({ name: "", qty: 1, price: 0 });

    for (const it of items) {
      flat.push({ name: `${it.qty}× ${it.name}`, qty: 1, price: 0 });

      if (it.modifiers?.length) {
        for (const m of it.modifiers) {
          if (!m) continue;
          flat.push({ name: `  • ${m}`, qty: 1, price: 0 });
        }
      }
      if (it.note && String(it.note).trim() !== "") {
        flat.push({ name: `  ✎ ${String(it.note).trim()}`, qty: 1, price: 0 });
      }
      flat.push({ name: "", qty: 1, price: 0 });
    }

    flat.push({ name: "------------------------------", qty: 1, price: 0 });
    flat.push({ name: "www.itable.app", qty: 1, price: 0 });

    // Iskoristi postojeći driver/kanal
    await printAfterFiscal(`ORDER #${code}`, flat, opts);
  } catch (e) {
    console.warn("printOrderTicket failed", e);
  }
}

